export default function Footer() {
    return (
        <div style={{width: '100%', height: '600px', backgroundColor: '#f9f7f3'}} />
    )
}